// Spustí sa po načítaní stránky
document.addEventListener('DOMContentLoaded', () => {

  // Nájdeme všetky unit price bloky (pre prípad viacerých sekcií na stránke)
  const wrappers = document.querySelectorAll('.unit-price-wrapper');

  wrappers.forEach((wrapper) => {

    // Získame ID sekcie (Shopify používa sectionId na identifikáciu komponentov)
    const sectionId = wrapper.dataset.sectionId;

    // Element, kam sa bude zapisovať cena za jednotku
    const output = document.getElementById(`unit-price-${sectionId}`);

    // JSON script, kde máme mapu variantId → unit price text (vygenerované z Liquidu)
    const dataScript = document.getElementById(`unit-price-data-${sectionId}`);

    // Ak niečo chýba, nemá zmysel pokračovať
    if (!output || !dataScript) return;

    // Parse JSON dát z Liquidu
    let unitPriceMap = {};
    try {
      unitPriceMap = JSON.parse(dataScript.textContent);
    } catch (e) {
      console.error('Unit price JSON parse error:', e);
      return;
    }

    // Funkcia na nájdenie inputu s aktuálnym variantom (Shopify form)
    function findVariantInput() {
      return wrapper.closest('section')?.querySelector('form [name="id"]')
        || document.querySelector(`form [name="id"]`);
    }

    // Hlavná funkcia: prepíše unit price podľa aktuálne zvoleného variantu
    function updateUnitPrice() {
      const variantInput = findVariantInput();
      if (!variantInput) return;

      const variantId = variantInput.value;

      // Z JSON mapy zoberieme správny text (napr. "8,90 EUR / 1 kg")
      const unitPriceText = unitPriceMap[variantId];

      // Ak existuje cena → zobrazíme
      if (unitPriceText && unitPriceText.trim() !== '') {
        output.innerHTML = unitPriceText;
        wrapper.style.display = '';
      } 
      // Ak variant nemá unit price → skryjeme
      else {
        output.innerHTML = '';
        wrapper.style.display = 'none';
      }
    }

    // Listener na zmenu variantu (select, radio alebo hidden input)
    document.addEventListener('change', (event) => {
      if (
        event.target.matches('variant-selects select') ||   // dropdown varianty (Dawn)
        event.target.matches('fieldset input[type="radio"]') || // radio varianty
        event.target.matches('form [name="id"]') // hidden input (fallback)
      ) {
        // Malý delay → Shopify musí najprv aktualizovať hodnotu variantu
        setTimeout(updateUnitPrice, 100);
      }
    });

    // Fallback: sleduje zmenu hodnoty variant inputu (niektoré témy nespúšťajú change správne)
    const variantInput = findVariantInput();
    if (variantInput) {
      let lastValue = variantInput.value;

      setInterval(() => {
        if (variantInput.value !== lastValue) {
          lastValue = variantInput.value;
          updateUnitPrice();
        }
      }, 200);
    }

    // Inicializácia pri načítaní stránky
    updateUnitPrice();
  });
});